import { useState, useEffect, useContext } from 'react';
import { UserContext } from 'context-providers/user-provider';
import { HashedUserInfo, hashUserInfo } from 'lib/helpers/hash-user-info';

const defaultHashedUserInfo: HashedUserInfo = {
  hashedFirstName: '',
  hashedLastName: '',
  hashedEmail: '',
  hashedPhone: '',
  hashedZipCode: '',
  hashedCity: '',
  hashedState: '',
};

export const useHashAccountInfo = () => {
  const { userState } = useContext(UserContext);
  const [hashedAccountInfo, setHashedAccountInfo] = useState<HashedUserInfo>(
    defaultHashedUserInfo,
  );
  const [isAccountInfoEmpty, setIsAccountInfoEmpty] = useState<boolean>(true);

  useEffect(() => {
    const fetchHashedInfo = async () => {
      if (userState) {
        const relevantUserState = {
          firstName: userState.firstName,
          lastName: userState.lastName,
          email: userState.email,
          phone: userState.phone,
          account: {
            details: {
              shipping_addresses:
                userState.account?.details?.shipping_addresses || [],
            },
          },
        };
        setIsAccountInfoEmpty(false);
        const hashedInfo = await hashUserInfo(relevantUserState);
        setHashedAccountInfo(hashedInfo);
      } else {
        setIsAccountInfoEmpty(true);
      }
    };

    fetchHashedInfo();
  }, [userState]);

  return { hashedAccountInfo, isAccountInfoEmpty };
};
